import clsx from "clsx"
import { useTheme } from "next-themes"

import { ReactComponent as AppIconDark } from "@assets/images/icons/app-icon-dark.svg"
import { ReactComponent as AppIconLight } from "@assets/images/icons/app-icon-light.svg"

import styles from "./AppIcon.module.scss"
import { AppIconProps } from "./AppIcon.types"

export default function AppIcon(props: AppIconProps) {
    const { className, themeOverride, ...rest } = props
    const { resolvedTheme } = useTheme()

    const isLight = themeOverride ? themeOverride === "light" : resolvedTheme === "light"
    const Icon = isLight ? AppIconDark : AppIconLight

    return <Icon className={clsx(styles.base, className)} {...rest} />
}
